// extracted by mini-css-extract-plugin
module.exports = {"desc_container":"Desc_desc_container__NrKyt","desc_content":"Desc_desc_content__2BlvJ","title":"Desc_title__2U9I4","line":"Desc_line__3_01U","desc":"Desc_desc__2BDl4"};